export const primaryNav = {
  toggle() {
    const items = document.querySelectorAll('.scs-header .menu > .menu-item');
    let activeItem = null;

    for (let i = 0; i < items.length; i++) {
      const toggle = items[i].querySelector('span[role="button"]');

      toggle.addEventListener('click', (e) => {
        e.preventDefault();

        if (items[i].classList.contains('active')) {
          items[i].classList.remove('active');
        } else {
          clearActive(items, items[i]);
          items[i].classList.add('active');

          clickedOutside(items[i], toggle, () => {
            items[i].classList.remove('active');
          });
        }
      });
    }
  },
  search() {
    const searchbar = document.querySelector('.util-search');
    const searchToggle = document.querySelector('.util-search .util-search-btn');
    const searchClose = document.querySelector('.util-search .util-search-close');
    const localeDropdown = document.querySelector('.locale-selector');
    const contactButton = document.querySelector('.util-nav > .nav-item');

    if (searchToggle) {
      searchToggle.addEventListener('click', function (e) {
        e.preventDefault();

        if (searchbar.classList.contains('active')) {
          searchbar.submit();
        } else {
          searchbar.classList.add('active');
          if (localeDropdown) localeDropdown.classList.add('hide');
          contactButton.classList.add('hide');
        }
      });
    }

    if (searchClose) {
      searchClose.addEventListener('click', function () {
        searchbar.classList.remove('active');
        if (localeDropdown) localeDropdown.classList.remove('hide');
        contactButton.classList.remove('hide');
      });
    }
  },
};

function clickedOutside(el, toggle, callback) {
  document.addEventListener('click', (e) => {
    var isClickInside = el.contains(e.target);

    if (!isClickInside && e.target != toggle) {
      callback();
    }
  });
}

function clearActive(items, el) {
  for (let i = 0; i < items.length; i++) {
    if (items[i] != el) {
      items[i].classList.remove('active');
    }
  }
}
